import { ThunkAction } from 'redux-thunk'

import config from 'admin/config/main'
import { reduxDependenciesType } from 'admin/redux/create'
import { State } from 'admin/redux/ducks'
import { Administrators } from 'admin/types'
import createApiReducer, {
  requestDataFor,
  receiveDataFor,
  handleErrorFor,
} from 'redux/utils/createApiDuck'
import { APIState, PersonType, ErrorType } from 'types'


const moduleName = `${config.appName  }/invoiceRecipientAdmins`

export default createApiReducer(moduleName)

export function fetchInvoiceRecipientAdmins(
  orgAccountId: string,
  invoiceRecipientId: string,
): ThunkAction<Promise<Administrators[] | ErrorType>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api
      .getInvoiceRecipientAdmins(orgAccountId, invoiceRecipientId)
      .then(data => {
        dispatch(receiveDataFor(moduleName)(data))
        return data
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export function createInvoiceRecipientAdmin(
  orgAccountId: string,
  invoiceRecipientId: string,
  person: PersonType,
): ThunkAction<Promise<string | ErrorType>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api
      .createInvoiceRecipientAdmin(orgAccountId, invoiceRecipientId, person)
      .then(kimId => {
        dispatch(fetchInvoiceRecipientAdmins(orgAccountId, invoiceRecipientId))
        return kimId
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export function inactivateInvoiceRecipientAdmin(
  invoiceRecipientId: string,
  kimId: number,
): ThunkAction<Promise<boolean | ErrorType>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api
      .inactivateInvoiceRecipientAdmin(invoiceRecipientId, kimId)
      .then(data => {
        dispatch(receiveDataFor(moduleName)(data))
        return data
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export interface InvoiceRecipientAdminsState extends APIState {
  data: Administrators | null
}
